export function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

/* ── Wyprawa w Nieznane ──────────────────────────────────────────────────────
   Lustro `backend/utils/ventureUtils.js`. Standardowo Wyprawa odsłania 2 karty
   (po jednej ze Ścieżki), a synergie `VENTURE_DRAW_BONUS` podbijają tę liczbę;
   nadwyżka rozkłada się na przemian, zaczynając od Męstwa. */

export const VENTURE_BASE_DRAW = 2;

export function ventureDrawCounts(player) {
  const bonus = Math.max(0, Number(player?.ventureDrawBonus) || 0);
  const total = VENTURE_BASE_DRAW + bonus;
  return { total, courage: Math.ceil(total / 2), wisdom: Math.floor(total / 2) };
}

/** Zdejmuje z talii do `count` pierwszych kart, które nie są Wydarzeniem. */
export function takeNonEventCards(deck, count) {
  const taken = [];
  const removals = [];
  let i = 0;
  while (i < deck.length && taken.length < count) {
    const id = deck[i];
    if (typeof id === 'string' && !id.startsWith('event_')) {
      deck.splice(i, 1);
      removals.push({ index: i, id });
      taken.push(id);
    } else {
      i++;
    }
  }
  return { taken, removals };
}

/** Cofa `takeNonEventCards` — wstawia karty od ostatniej do pierwszej. */
export function restoreDrawnCards(deck, removals) {
  for (let i = removals.length - 1; i >= 0; i--) {
    deck.splice(removals[i].index, 0, removals[i].id);
  }
}
